import React from 'react';
import PropTypes from 'prop-types';
import MoveTo from 'moveto';
import { css } from '@bd/bdui-styles/emotion';
import { withRouter } from 'react-router-dom';

function scrollToTop(ref) {
  setTimeout(() => {
    const moveTo = new MoveTo({
      tolerance: 100,
    });
    moveTo.move(ref);
  }, 100);
}

const styles = css`
  .AccordionToggle_button {
    cursor: pointer;
  }

  .AccordionToggle_content {
    height: 0;
    overflow-y: hidden;
    transition: height 0.5s;

    @media (min-width: 992px) {
      height: auto;
      transition: none;
    }
  }
`;

function elemIsVisible(elem) {
  return elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
}

class AccordionToggle extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showContent: false,
      allowToggle: false,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      const { location, openOnId, isOpen } = this.props;
      const active = location.hash.substr(1) === openOnId.replace('#', '');

      if (active || isOpen) {
        this.changeVisibleState(true);
      }

      this.checkAllowToggle();
    }, 500);

    window.addEventListener('resize', this.checkAllowToggle);
  }

  componentWillReceiveProps(nextProps) {
    setTimeout(() => {
      const { location, openOnId } = nextProps;
      const active = location.hash.substr(1) === openOnId.replace('#', '');

      if (active) {
        this.changeVisibleState(true);
      }
    }, 100);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.checkAllowToggle);
  }

  setControlRef = ref => {
    this.controlRef = ref;
  }

  setSizeRef = ref => {
    this.sizeRef = ref;
  }

  setContainerRef = ref => {
    this.containerRef = ref;
  }

  checkAllowToggle = () => {
    this.setState({
      allowToggle: elemIsVisible(this.controlRef),
    });
  }

  changeVisibleState = showContent => {
    this.setState({
      showContent,
    }, () => {
      if (showContent) {
        const element = this.sizeRef;
        let height = element.getBoundingClientRect().height;
        const style = window.getComputedStyle(element);

        // height: element height + vertical padding & borders
        // now we just need to add vertical margins
        height = ['top', 'bottom']
          .map(side => {
            return parseInt(style[`margin-${side}`], 10);
          })
          .reduce((total, side) => {
            return total + side;
          }, height);

        this.containerRef.style.height = `${height}px`;
      } else {
        this.containerRef.style.height = null;
      }
    });
  };

  toggleContent = e => {
    const { showContent } = this.state;

    if (!elemIsVisible(this.controlRef) || (e.which && ![32, 13].includes(e.which))) {
      return;
    }

    this.changeVisibleState(!showContent);
    if (this.props.scollToTop) {
      scrollToTop(this.controlRef);
    }
  }

  render() {
    const { button, children } = this.props;
    const { allowToggle, showContent } = this.state;
    return (
      <div className={styles}>
        <div className="d-sm-block d-md-block d-lg-none" ref={ref => this.setControlRef(ref)} />

        {
          allowToggle ?
          (
            <div className="AccordionToggle_button" role="button" tabIndex="0" onClick={this.toggleContent} onKeyDown={this.toggleContent}>
              {button({ contentVisible: showContent })}
            </div>
          ) :
          button({})
        }

        <div className="AccordionToggle_content" ref={ref => this.setContainerRef(ref)}>
          <div className="AccordionToggle_contentInterior" ref={ref => this.setSizeRef(ref)}>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

AccordionToggle.propTypes = {
  button: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool,
  location: PropTypes.object.isRequired,
  openOnId: PropTypes.string,
  scollToTop: PropTypes.bool,
};

AccordionToggle.defaultProps = {
  isOpen: undefined,
  openOnId: undefined,
  scollToTop: true,
};

export default withRouter(AccordionToggle);



// WEBPACK FOOTER //
// ./src/components/AccordionToggle.js